/** AgentsEmptyState — placeholder shown when /settings/agents has no agent selected. */

export default function AgentsEmptyState() {
  return (
    <div className="flex flex-col items-center gap-2 py-16 text-center">
      <h2 className="text-lg font-semibold text-foreground">Select an agent</h2>
      <p className="text-sm text-muted-foreground">
        Use the picker above to choose an agent to configure.
      </p>
    </div>
  );
}
